export const dark = '#282c34';
